import {type FC, useCallback, useEffect, useRef, useState} from 'react';
import useCenterStore from '../../store/useCenterStore.ts';
import Webcam from 'react-webcam';
import {FullScreenIcon, IpTvPageStyleWrapper, WebCamWrapper} from './types/IpTvPage.styled.ts';
import {setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import useGlobalStore from '../../store/useGlobalStore.ts';
import FullScreenSVG from '../../assets/broadcast/scale-expanding.svg';

const IpTvPage: FC = () => {
    const videoRef = useRef<Webcam | null>(null);
    const {allDevices, captureBoardD, captureBoardAudioD, audioOutputD, setAllDevices, captureBoardMediaStream} =
        useCenterStore();

    const fetchData = async () => {
        if (allDevices.length < 3) {
            await setAllDevices();
        }
    };

    useEffect(() => {
        fetchData();
        setFocus('iptv');
    }, []);

    useEffect(() => {
        if (videoRef.current?.video && captureBoardMediaStream) {
            const video = videoRef.current.video;
            video.srcObject = captureBoardMediaStream;
            video.onloadedmetadata = () => {
                video.play().catch((error) => {
                    console.error('비디오 재생 실패:', error);
                });
            };
        } else if (videoRef.current?.video && !captureBoardMediaStream) {
            videoRef.current.video.srcObject = null;
        }
    }, [captureBoardMediaStream]);

    useEffect(() => {
        if (videoRef.current?.video && audioOutputD) {
            const video = videoRef.current.video;
            if (video.setSinkId !== undefined) {
                video.setSinkId(audioOutputD.deviceId).catch((error) => {
                    console.error('오디오 출력 디바이스 설정 실패:', error);
                });
            }
        }
    }, [audioOutputD]);

    const {isFullScreen, setFullScreen} = useGlobalStore();
    const [showFullScreenIcon, setShowFullScreenIcon] = useState(true);
    const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const showIconAndStartTimer = useCallback(() => {
        setShowFullScreenIcon(true);
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
        }
        hideTimeoutRef.current = setTimeout(() => {
            setShowFullScreenIcon(false);
        }, 5000);
    }, []);

    useEffect(() => {
        const handleFocusChange = () => {
            showIconAndStartTimer();
        };
        document.addEventListener('keydown', handleFocusChange);
        document.addEventListener('focusin', handleFocusChange);
        showIconAndStartTimer();
        return () => {
            document.removeEventListener('keydown', handleFocusChange);
            document.removeEventListener('focusin', handleFocusChange);
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
            }
        };
    }, [showIconAndStartTimer]);

    const {ref, focused} = useFocusable({
        focusKey: 'iptv-page-full-icon',
        onEnterPress: () => setFullScreen(!isFullScreen),
        onFocus: () => {
            showIconAndStartTimer();
        },
        onArrowPress: (direction) => {
            if (direction === 'left') {
                setFocus(`iptv`);
                return false;
            }
            return false;
        },
    });

    if (allDevices.length === 0) {
        return (
            <IpTvPageStyleWrapper>
                <div>디바이스 정보를 불러오는 중...</div>
            </IpTvPageStyleWrapper>
        );
    }

    return (
        <IpTvPageStyleWrapper>
            {allDevices.length > 3 ? (
                <WebCamWrapper $isFullScreen={isFullScreen}>
                    <Webcam
                        style={{width: '100%'}}
                        ref={videoRef}
                        audio={true}
                        videoConstraints={captureBoardD!}
                        audioConstraints={captureBoardAudioD!}
                    />
                </WebCamWrapper>
            ) : (
                <>
                    <h3>Error</h3>
                    <div>"장치가 정상적으로 인식되지 않았습니다."</div>
                    <h3>Device List</h3>
                    <ul>
                        {allDevices.map((device, index) => (
                            <li key={index}>
                                {`Kind: ${device.kind}, Label: ${device.label}, Device ID: ${device.deviceId}`}
                            </li>
                        ))}
                    </ul>
                </>
            )}
            {/*{(allDevices.length > 3) ?*/}
            {/*    <FullScreenIcon ref={ref} $isFullScreen={isFullScreen} $show={isFullScreen} $focused={focused}*/}
            {/*                    onClick={() => setFullScreen(!isFullScreen)}>*/}
            {/*        <img*/}
            {/*            src={FullScreenSVG}*/}
            {/*            alt="third-layout"*/}
            {/*        />*/}
            {/*    </FullScreenIcon>*/}
            {/*    : null}*/}
        </IpTvPageStyleWrapper>
    );
};

export default IpTvPage;
